(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name cycle.service:AdminCycleService
	 * 
	 * @description
	 * 
	 */
	angular.module('cycle').service('AdminCycleService', AdminCycleService);

	function AdminCycleService(AdminCycleFactory, RemoteService,
			CommonMasterData) {

		var self = this;

		// store retrieved data
		var model = {
			cycleDTO : AdminCycleFactory.getCycleDTO(),
			cycleSearchDTO : AdminCycleFactory.getCycleSearchDTO,
			cycleSaveRequest : AdminCycleFactory.getCycleSaveRequest,
			cycleDeleteRequest : AdminCycleFactory.getCycleDeleteRequestDTO
		};

		self.getCycleDTO = function() {
			model.cycleDTO = AdminCycleFactory.getCycleDTO();
			return model.cycleDTO;
		}

		self.getAdaptedCycleSearchDTO = function(searchResponse) {
			model.cycleSearchDTO = AdminCycleFactory
					.getFormattedCycleSearchDTO(searchResponse);
			return model.cycleSearchDTO;
		}

		self.setSaveCycleRequest = function(cycleSearchDTO) {
			model.cycleSaveRequest = AdminCycleFactory
					.getFormattedCycleSaveRequest(cycleSearchDTO);
			return model.cycleSaveRequest;
		}
		
		self.setDeleteCycleRequest = function(selectedCycleDTO) {
			model.cycleDeleteRequest = AdminCycleFactory
					.getFormattedCycleDeleteRequestDTO(selectedCycleDTO);
			return model.cycleDeleteRequest;
		}

		/**
		 * loadAdminCycles
		 * 
		 * @param successFn
		 * @param errorFn
		 */
		self.loadAdminCycles = function(showAll, successFn, errorFn) { 
			RemoteService.loadAdminCycles(showAll).then(function(response) { 
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};

		/**
		 * saveAdminCycle
		 * 
		 * @param successFn
		 * @param errorFn
		 */
		self.saveAdminCycle = function(saveCycleReq, successFn, errorFn) {
			RemoteService.saveAdminCycle(saveCycleReq).then(function(response) { 
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};
		

		/**
		 * deleteAdminCycle
		 * 
		 * @param successFn
		 * @param errorFn
		 */
		self.deleteAdminCycle = function(deleteCycleReq, successFn, errorFn) {
			RemoteService.deleteAdminCycle(deleteCycleReq).then(function(response) { 
				successFn(response);
			}, function(error) {
				errorFn(error.msg);
			});
		};
	}
})();